(function(angular, module) {var filters, specialTags;

specialTags = {
  alliance: 'alliance',
  allied: 'alliance',
  empire: 'empire',
  imperial: 'empire',
  rocket: 'rocket',
  space: 'rocket',
  star: 'star',
  stars: 'star',
  beer: 'beer'
};

filters = {
  tagClass: function() {
    return function(tag) {
      var classes, i, len, part, parts;
      if (!tag) {
        return;
      }
      classes = ["tag-" + tag.slug];
      if (tag.value) {
        parts = tag.value.split(/[-_]/);
        for (i = 0, len = parts.length; i < len; i++) {
          part = parts[i];
          if (specialTags[part]) {
            classes.push("tag-special-" + specialTags[part]);
          }
        }
      }
      return classes;
    };
  }
};

module.filter(filters);
})(angular, angular.module("dybTags"));